import {Tenant, Permission} from "../../model";
import {ApiBuilder} from "..";

const updatePermissions = (builder: ApiBuilder) =>
  builder.mutation<Tenant, {entityIds: string[]; permissions: Permission[]}>({
    query: body => ({
      url: "/api/catalog/update-permissions",
      method: "POST",
      body,
    }),
  });

export {updatePermissions};
